const dustjs = require('dustjs');
const Backbone = require('backbone');
const _facetLimitByResults = require('store/global/pages/categories/_facet_limit_by_results.dust');

module.exports = Backbone.View.extend({
	events: {
		'click .js-facet-item-remove': '_onFacetRemove',
		'click .js-facet-remove-all': '_onAllFacetRemove'
	},
	initialize() {
		this.collection.on('update', this.render, this);
	},
	_onAllFacetRemove(e) {
		e.preventDefault();
		this.collection.trigger('facets:items:clearall');
	},
	_onFacetRemove(e) {
		e.preventDefault();
		const $el = $(e.currentTarget);

		this.collection.trigger('facets:items:set', {
			groupName: $el.data('groupname'),
			facetValue: decodeURIComponent(String($el.data('facetvalue'))),
			selected: false
		});
	},
	getViewModel() {
		const viewModel = {
			limitByFacets: [],
			pathname: '#'
		};
		this.collection.where({ selected: true }).forEach((facetGroup) => {
			viewModel.limitByFacets.push({
				groupName: facetGroup.get('groupName'),
				groupDisplayName: facetGroup.get('groupDisplayName'),
				facets: facetGroup
					.get('facetItemCollection')
					.toJSON()
					.filter((facet) => facet.selected)
			});
		});
		return viewModel;
	},
	render() {
		dustjs.render(_facetLimitByResults, this.getViewModel(), this._handleDustResults.bind(this));
		return this;
	},
	_handleDustResults(err, markup) {
		if (!err) {
			this.$el.html(markup);
		}
	}
});
